<template>
  <section class="hero custom-color">
    <div class="hero-body">
      <p class="title">
        {{ titulo }}
      </p>
      <p class="subtitle">
        {{ subtitulo }}
      </p>
    </div>
  </section>
</template>

<script>
export default {
  name: "mensajeInicial",
  props: ["titulo", "subtitulo"],
};
</script>

<style scoped>
/* En tu archivo de estilos CSS personalizado */
.custom-color {
  background-color: #8ca1fd; /* Cambia esto al color que desees */
  /* Otros estilos según sea necesario */
}
</style>
